import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMenuOpen = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.5 12.1575V10.1719H22.4486L19.9307 7.65408L21.3348 6.25L26.25 11.1652L21.3348 16.0804L19.9307 14.6766L22.4486 12.1576L7.5 12.1575Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.1499 16.1304H3.74988V18.1166H18.1499V16.1304Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.1499 22.0892H3.74988V24.0755H18.1499V22.0892Z",
			fill: "currentColor"
		})
	]
});
export default SvgMenuOpen;
